/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const GenderEnum = {
    Unknown: 'UNKNOWN',
    Male: 'MALE',
    Female: 'FEMALE',
    Diverse: 'DIVERSE'
} as const;
export type GenderEnum = typeof GenderEnum[keyof typeof GenderEnum];

